import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { supportedLngs, defaultLng } from './languages';

/**
 * i18next is used here primarily for language state management and detection.
 * Actual translation is handled by AutoTranslate (MutationObserver-based DOM replacement).
 *
 * Bundled English resources are provided so t() calls in the Sidebar still work.
 * For all other components, AutoTranslate handles translation automatically.
 */
const enFallback: Record<string, string> = {
  'sidebar.navigation': 'Navigation',
  'sidebar.loading': 'Loading menu...',
  'sidebar.footer_brand': 'iTEACH',
  'sidebar.footer_version': 'v2.0',
  'sidebar.language': 'Language',
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs,
    fallbackLng: defaultLng,
    defaultNS: 'common',
    ns: ['common'],

    resources: {
      en: { common: enFallback },
      // id and hi have empty resources — AutoTranslate handles actual translation
      id: { common: {} },
      hi: { common: {} },
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18next;
